// extracted by mini-css-extract-plugin
module.exports = {"fullScreenPopup":"fullScreenPopup_fullScreenPopup__Zzj9s","top":"fullScreenPopup_top__bLFMz","main":"fullScreenPopup_main__Fw6oL"};